/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inclusive_Great_Cow_SkipInputs */

const fr_inclusive_great_cow_skip = /** @type {(inputs: Inclusive_Great_Cow_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

/**

* @param {Inclusive_Great_Cow_SkipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const inclusive_great_cow_skip = /** @type {((inputs?: Inclusive_Great_Cow_SkipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inclusive_Great_Cow_SkipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_inclusive_great_cow_skip(inputs)
});